<template>
  <!--  解决方案 -->
  <div class="">
    <HeaderTop />
    <MenuPage />

    <BannerDetail
      :backgroundImage="require('../assets/img/banner5.jpg')"
      :title="$t('solution.items[1].title')"
      :description="$t('solution.items[1].description')"
    />
 <div class="title-home-main">
      <div class="title-home-box">
        <div class="title-home-one">{{ $t("Solutiondec1") }}</div>
        <div><i class="iconfont icon-hengtiao"></i></div>
      </div>
    </div>

    <div class="solution-main">
      <div class="solution-box">
        <div class="solution-title-one">{{ $t("Solutiondec35") }}</div>
      </div>
    </div>

    <div class="title-home-main">
      <div class="title-home-box">
        <div class="title-home-one">{{ $t("Solutiondec2") }}</div>
        <div><i class="iconfont icon-hengtiao"></i></div>
      </div>
    </div>

      <div class="solution-main">
      <div class="solution-box-two">
        <div class="solution-box-three">
          <div class="title-top">{{ $t("Solutiondec36") }}</div>
          <div class="title-bottom">{{ $t("Solutiondec40") }}</div>
        </div>
        <div class="solution-box-three">
          <div class="title-top">{{ $t("Solutiondec37") }}</div>
          <div class="title-bottom">{{ $t("Solutiondec41") }}</div>
        </div>
        <div class="solution-box-three">
          <div class="title-top">{{ $t("Solutiondec38") }}</div>
          <div class="title-bottom">{{ $t("Solutiondec42") }}</div>
        </div>
        <div class="solution-box-three">
          <div class="title-top">{{ $t("Solutiondec39") }}</div>
          <div class="title-bottom">{{ $t("Solutiondec43") }}</div>
        </div>
      </div>
    </div>


    <div class="title-home-main">
      <div class="title-home-box">
        <div class="title-home-one">{{ $t("Solutiondec3") }}</div>
        <div><i class="iconfont icon-hengtiao"></i></div>
      </div>
    </div>

     <div class="solution-main">
      <div class="solution-box">
        <div class="solution-title-one">{{ $t("Solutiondec44") }}</div>

        <div class="img-box">
           <img :src=" $t('image3') " class="img-li" />
        </div>
          <div class="img-box">
          <img :src=" $t('image4') " class="img-li" />
        </div>
      </div>
    </div>

    <div class="title-home-main">
      <div class="title-home-box">
        <div class="title-home-one">{{ $t("Solutiondec4") }}</div>
        <div><i class="iconfont icon-hengtiao"></i></div>
      </div>
    </div>


     <div class="solution-main">
      <div class="solution-box-four">
        <div class="item-two">
          <img src="../assets/img/an4.png" class="item-one-img" />
          <div class="title-home-two">{{ $t("Solutiondec45") }}</div>
          <p class="solution-title-one">{{ $t("Solutiondec49") }}</p>
        </div>
        <div class="item-two">
          <img src="../assets/img/an5.png" class="item-one-img"  />
          <div class="title-home-two">{{ $t("Solutiondec46") }}</div>
          <p class="solution-title-one">{{ $t("Solutiondec50") }}</p>
        </div>
        <div class="item-two">
          <img src="../assets/img/an6.png" class="item-one-img"  />
          <div class="title-home-two">{{ $t("Solutiondec47") }}</div>
          <p class="solution-title-one">{{ $t("Solutiondec51") }}</p>
        </div>
         <div class="item-two">
          <img src="../assets/img/an7.png" class="item-one-img"  />
          <div class="title-home-two">{{ $t("Solutiondec48") }}</div>
          <p class="solution-title-one">{{ $t("Solutiondec52") }}</p>
        </div>
      </div>
    </div>



    <div class="title-home-main">
      <div class="title-home-box">
        <div class="title-home-one">{{ $t("Solutiondec5") }}</div>
        <div><i class="iconfont icon-hengtiao"></i></div>
      </div>
    </div>


      <div class="solution-main">
      <div class="solution-box-four">
        <div class="item-two">
          <img src="../assets/img/an16.png" class="item-one-img" />
          <div class="title-home-two">{{ $t("Solutiondec53") }}</div>
          <p class="solution-title-one">{{ $t("Solutiondec57") }}</p>
        </div>
        <div class="item-two">
          <img src="../assets/img/an17.png" class="item-one-img"  />
          <div class="title-home-two">{{ $t("Solutiondec54") }}</div>
          <p class="solution-title-one">{{ $t("Solutiondec58") }}</p>
        </div>
        <div class="item-two">
          <img src="../assets/img/an18.png" class="item-one-img"  />
          <div class="title-home-two">{{ $t("Solutiondec55") }}</div>
          <p class="solution-title-one">{{ $t("Solutiondec59") }}</p>
        </div>
         <div class="item-two">
          <img src="../assets/img/an19.png" class="item-one-img"  />
          <div class="title-home-two">{{ $t("Solutiondec56") }}</div>
          <p class="solution-title-one">{{ $t("Solutiondec60") }}</p>
        </div>
      </div>
    </div>

    <div class="title-home-main">
      <div class="title-home-box">
        <div class="title-home-one">{{ $t("Solutiondec6") }}</div>
        <div><i class="iconfont icon-hengtiao"></i></div>
      </div>
    </div>

      <div class="solution-main">
      <div class="solution-box-four">
        <div class="item-three">
          <img src="../assets/img/jie5.jpg" class="item-three-img" />
          <div class="title-home-two">{{ $t("Solutiondec61") }}</div>
          <p class="solution-title-one">{{ $t("Solutiondec63") }}</p>
        </div>
        <div class="item-three">
          <img src="../assets/img/jie2.jpg" class="item-three-img"  />
          <div class="title-home-two">{{ $t("Solutiondec62") }}</div>
          <p class="solution-title-one">{{ $t("Solutiondec64") }}</p>
        </div>
        
      </div>
    </div>
 

    <div class="footer-main">
      {{ $t("footertitile") }}
    </div>
  </div>
</template>

<script>
import MenuPage from "../components/MenuPage.vue";
import HeaderTop from "../components/HeaderTop.vue";
import BannerDetail from "@/components/BannerDetail.vue";
export default {
  components: { HeaderTop, MenuPage, BannerDetail },
  name: "NewsPage",
   mounted() {
    this.scrollToTop();
  },
  data() {
    return {
      companyName: "",
      contactPerson: "",
      contactInfo: "",
      requirements: "",
    };
  },
  methods: {
      scrollToTop() {
      window.scrollTo(0, 0);
    },
    handleSubmit() {
      // 阻止表单的默认提交行为
      alert("提交成功"); // 提示提交成功
      // 这里可以添加进一步的逻辑，比如将表单数据发送到服务器
      console.log({
        companyName: this.companyName,
        contactPerson: this.contactPerson,
        contactInfo: this.contactInfo,
        requirements: this.requirements,
      });
    },
  },
};
</script>
<style scoped>
</style>
